<div [class.energymonitor-chart]="navigationService.position() === 'left'" #energymonitorChart>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="false" name="live-energymonitor"></ngx-spinner>
  <svg [style.width.px]="width" [style.height.px]="height" overflow="visible">
    <!-- !graphic -->
    <svg:g [attr.transform]="translation">
      <svg:g consumptionsection></svg:g>
      <svg:g gridsection></svg:g>
      <svg:g productionsection></svg:g>
      <svg:g storagesection></svg:g>
    </svg:g>
  </svg>
</div>
